import { ObjectBuilder } from 'components/WorkspaceEditor/factories'
import {
    ElementType,
    PartTypes,
} from 'pages/ProjectsPage/WorkspacePage/components/constants'
import { useCallback } from 'react'
import { useShallowSelector, useWorkspace2Store } from '../../../Workspace2Store'
import { PromoteDemoteVariables } from '../types'
import { findNodeById } from '../utils/nodeHelpers'

/**
 * Builds promote/demote mutation variables from a node's current position.
 * The local move already stamped that position on the node — this only reads it back.
 */
export const usePromoteDemoteService = () => {
    const { selectedProjectElementNode } = useShallowSelector((s) => ({
        selectedProjectElementNode: s.selectedProjectElementNode,
    }))

    const buildInputVariables = useCallback(
        (contentItemId: string): PromoteDemoteVariables | null => {
            // Fresh read, not a hook selector — a closure would see the pre-move tree.
            const contentItemViewNodes = useWorkspace2Store.getState()
                .contentItemViewNodes
            const currentNode = findNodeById(contentItemViewNodes, contentItemId)
            if (!currentNode) return null

            const promoteDemonteContentInput = new ObjectBuilder<
                PromoteDemoteVariables['promoteDemonteContentInput']
            >()
                .set('contentId', currentNode.dtvItemId || '')
                .set(
                    'documentTemplateViewId',
                    currentNode.documentTemplateViewId || ''
                )
                .set('contentItemId', currentNode.id || '')
                .set('parentContentId', currentNode.dtvParentId)
                .set('parentContentItemId', currentNode.dtvContentItemParentId)
                .set('productFamilyId', currentNode.productFamilyId || '')
                .set('order', currentNode.order ?? 0)
                .set(
                    'projectNuggetId',
                    selectedProjectElementNode?.elementType ===
                        ElementType.PRODUCTTYPE
                        ? selectedProjectElementNode.elementId ?? undefined
                        : undefined
                )
                .set(
                    'elementType',
                    !currentNode.dtvContentItemParentId &&
                        currentNode.partType === PartTypes.CONTENT_GROUP
                        ? ElementType.SUSTAINABILITY
                        : undefined
                )
                .set('topicContentItemsDetail', null)
                .build()

            return { promoteDemonteContentInput }
        },
        [selectedProjectElementNode]
    )

    return { buildInputVariables }
}
